(function() {
  'use strict';
  if (customElements.get('sizeguide-table-modal')) return;

  class SizeguideTableModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-sizeguide-dialog]');
      this.backdrop = this.querySelector('[data-sizeguide-backdrop]');
      this.tableBody = this.querySelector('[data-sizeguide-tbody]');
      this.table = this.querySelector('[data-sizeguide-table]');
      this.noData = this.querySelector('[data-sizeguide-nodata]');
      this.modalTitle = this.querySelector('[data-sizeguide-title]');
      this.heightHeader = this.querySelector('[data-sizeguide-height]');
      this.widthHeader = this.querySelector('[data-sizeguide-width]');
      this.sizeguideData = null;
      this.currentVariantKey = null;
      var idx = parseInt(this.dataset.materialOptionIndex, 10);
      this.materialOptionIndex = (idx > 0 && idx <= 3) ? idx : 1;

      var ds = this.querySelector('[data-sizeguide-json]');
      if (ds) {
        try {
          var d = JSON.parse(ds.textContent);
          if (typeof d === 'string') d = JSON.parse(d);
          this.sizeguideData = d;
        } catch (e) {
          console.error('Failed to parse sizeguide data:', e);
        }
      }

      this.querySelector('[data-sizeguide-close]')?.addEventListener('click', () => this.close());
      this.backdrop?.addEventListener('click', () => this.close());
      this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); this.close(); } });
      this.dialog?.addEventListener('cancel', (e) => { e.preventDefault(); });

      // Auto-update table when variant changes
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          if (!e.data?.variant) return;
          var key = e.data.variant['option' + this.materialOptionIndex] || '';
          this.currentVariantKey = key;
          if (this.dialog?.open) this.renderVariant(key);
        });
      }
    }

    open(variantKey) {
      var key = this.currentVariantKey != null ? this.currentVariantKey : variantKey;
      this.renderVariant(key);
      this.dialog?.showModal();
      this.backdrop?.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.dialog?.classList.add('dialog-closing');
      this.backdrop?.classList.remove('active');

      setTimeout(() => {
        this.dialog?.close();
        this.dialog?.classList.remove('dialog-closing');
        document.body.style.overflow = '';
      }, 150);
    }

    normalizeForMatch(s) {
      if (!s) return '';
      var n = s.toLowerCase().trim().replace(/[-_\s]+/g, '').replace(/[^a-z0-9]/g, '');
      var syn = { sweater: 'sweatshirt', trui: 'sweatshirt', pullover: 'sweatshirt', shirt: 'tshirt', tee: 'tshirt' };
      return syn[n] || n;
    }

    renderVariant(key) {
      if (!this.sizeguideData || !this.tableBody) return;
      var nk = this.normalizeForMatch(key), vd = null;

      if (this.sizeguideData.variants) {
        if (this.sizeguideData.variants[nk]) {
          vd = this.sizeguideData.variants[nk];
        } else {
          for (var [k, d] of Object.entries(this.sizeguideData.variants)) {
            var ndk = this.normalizeForMatch(k), ndl = this.normalizeForMatch(d.label || '');
            if (ndk === nk || ndl === nk || nk.includes(ndk) || ndk.includes(nk)) {
              vd = d;
              break;
            }
          }
        }
      }

      if (!vd || !vd.sizes || !vd.sizes.length) {
        if (this.table) this.table.style.display = 'none';
        if (this.noData) this.noData.style.display = 'block';
        return;
      }

      if (this.table) this.table.style.display = '';
      if (this.noData) this.noData.style.display = 'none';
      var hw = vd.sizes.some(s => s.height || s.width);
      if (this.heightHeader) this.heightHeader.style.display = hw ? '' : 'none';
      if (this.widthHeader) this.widthHeader.style.display = hw ? '' : 'none';

      this.tableBody.innerHTML = vd.sizes.map(s =>
        '<tr><td>' + (s.size || '-') + '</td>' +
        (hw ? '<td>' + (s.height || '-') + '</td><td>' + (s.width || '-') + '</td>' : '') +
        '</tr>'
      ).join('');

      if (this.modalTitle && vd.label) {
        var baseTitle = this.modalTitle.textContent.split(' - ')[0].trim();
        this.modalTitle.textContent = baseTitle + ' - ' + vd.label;
      }
    }
  }

  customElements.define('sizeguide-table-modal', SizeguideTableModal);
})();
